/**
 * The way in to Prest0 Inc.'s Sales Funnel, /activity/sales-funnel (Miles, 2026-11-03; docs/PLAN-sales-funnel-
 * 20261103.md): the account menu offers it, and /activity links to it, only in Prest0 Inc.'s workspace and only to
 * someone holding `growth.sales-funnel.view` — the key the page's route asks for, held by Prest0 Inc.'s Owner (forced)
 * and its Admins (derived), never granted to anyone else (the catalog marks it system-only and not assignable).
 *
 * Both halves are needed, as for the engineering page (useEngineeringAccess.ts): `hasPermission` answers true for the
 * owner of ANY workspace, while an internal key means something only in Prest0 Inc. The workspace is the ACTIVE one,
 * never the home org.
 *
 * This hides chrome only. The route's DeveloperRoute and the callable decide (salesFunnelGate.ts: an active Owner or
 * Admin of Prest0 Inc., a person, by role).
 */
import { PREST0_INC_ACCOUNT_ID } from '../config/internalAccess';

/** The key the page's route asks for (src/App.tsx), and so the key its way in asks for. */
export const SALES_FUNNEL_PAGE_KEY = 'growth.sales-funnel.view';

/** The permission answer the rule needs (useUsageVisibility's `loading` and `hasPermission`). */
export interface SalesFunnelPermissions {
  loading?: boolean;
  hasPermission?: (key: string) => boolean;
}

/** May the way in show, in this workspace, for this permission answer? False while it loads (fail closed). Pure. */
export function canSeeSalesFunnel(activeAccountId: string | null, perms: SalesFunnelPermissions): boolean {
  if (perms.loading || typeof perms.hasPermission !== 'function') return false;
  return activeAccountId === PREST0_INC_ACCOUNT_ID && perms.hasPermission(SALES_FUNNEL_PAGE_KEY);
}
